import * as Yup from 'yup';
import { TFunction } from 'i18next';

// export const ProductSearchValidationSchema = (t: TFunction) =>
//   Yup.object({
//     quantityMin: Yup.number().test(
//       'quantityMin-required',
//       t('valid_err_required'),
//       function (value) {
//         const { quantityMax } = this.parent;
//         if (!value && !quantityMax) {
//           return true;
//         }
//         return !!value;
//       }
//     ),
//     quantityMax: Yup.number().test(
//       'quantityMax-required',
//       t('valid_err_required'),
//       function (value) {
//         const { quantityMin } = this.parent;
//         if (!value && !quantityMin) {
//           return true;
//         }
//         return !!value;
//       }
//     ),
//   });
export const ProductSearchValidationSchema = (t: TFunction) =>
  Yup.object({
    quantityMin: Yup.number()
      .nullable()
      .max(Yup.ref('quantityMax'), t('MinLTEMax'))
      .test('quantityMin-required', t('valid_err_required'), function (value) {
        const { quantityMax } = this.parent;
        if (!value && !quantityMax) return true;
        return value !== undefined && value !== null;
      }),

    quantityMax: Yup.number()
      .nullable()
      .min(Yup.ref('quantityMin'), t('MaxGTEMax'))
      .test('quantityMax-required', t('valid_err_required'), function (value) {
        const { quantityMin } = this.parent;
        if (!value && !quantityMin) return true;
        return value !== undefined && value !== null;
      }),
  });

export type ProductSearchValidationSchemaType = ReturnType<
  typeof ProductSearchValidationSchema
>;
